// Source/Collection-Card/Select.ts
var Selector_Card = (variantId) => `.Boost-Search-Card[ data-product-id = '${variantId}' ] > div`;
function scrollToSelected() {
  const state = history.state ?? {};
  const { variantId } = window.ScrollBack ?? {};
  if (!variantId)
    return;
  history.replaceState({
    ...state,
    collection: {
      selected: null
    }
  }, "");
  window.ScrollBack = undefined;
  const selector = Selector_Card(variantId);
  const card = document.querySelector(selector);
  if (!card) {
    console.warn(`Failed to find card to scroll to!`, { variantId });
    return;
  }
  card.scrollIntoView({
    behavior: "smooth",
    inline: "center",
    block: "end"
  });
}
window.addEventListener("pageshow", (event) => {
  if (event.persisted)
    scrollToSelected();
});

// Source/Collection-Card/Furnish.ts
function furnish(item, html) {
  const parser = new DOMParser;
  const node = parser.parseFromString(html, "text/html");
  const meta = node.querySelector(`meta`);
  const isHidden = meta.dataset.isHidden === "true";
  item.dataset.isHidden = String(isHidden);
  const card = node.querySelector(`.Card-Product`);
  item.replaceChildren(card);
  item.addEventListener("click", (event) => {
    event.stopImmediatePropagation();
    event.stopPropagation();
  });
}

// Source/Collection-Card/Poll.ts
function pollFor(args) {
  const {
    interval = 100,
    selector,
    timeout = 1e4
  } = args;
  const start = Date.now();
  return new Promise((resolve, reject) => {
    const instance = setInterval(() => {
      try {
        const element = document.querySelector(selector);
        if (element) {
          clearInterval(instance);
          resolve(element);
          return;
        }
        const delta = Date.now() - start;
        if (delta >= timeout) {
          clearInterval(instance);
          reject();
          return;
        }
      } catch (exception) {
        console.error(exception);
      }
    }, interval);
  });
}

// Source/Collection-Card/mod.ts
var Pattern_Container = `
    .shopify-section
    .page-width
    .shopify-app-block
    .boost-sd-container
`;
var Pattern_List = `
    .shopify-section
    .page-width
    .shopify-app-block
`;
pollFor({ selector: Pattern_Container }).then(register).catch(() => {
  console.error(`Failed to find Boost AI's product list.`);
});
function register() {
  console.debug("BoostAI::Register");
  const observer = new MutationObserver(() => {
    let update = false;
    document.querySelectorAll(Pattern_Item).forEach((element) => {
      if (element.dataset.customized)
        return;
      element.dataset.customized = String(true);
      update = true;
    });
    if (update)
      afterRender();
  });
  const list = document.querySelector(Pattern_List);
  observer.observe(list, {
    childList: true
  });
  afterRender();
}
var Cache = new Map;
var Pattern_Item = `.boost-sd__product-item`;
var Marker_Product_Card = "\uD83D\uDCE6";
var Hub_Path = `/search`;
var Endpoint_Product_Card = `${Hub_Path}?q=${Marker_Product_Card}`;
async function afterRender() {
  const event = new CustomEvent("Boost:After-Render");
  window.dispatchEvent(event);
  document.body.classList.remove("boost-sd__g-no-scroll");
  let list = document.querySelector(`.boost-sd__filter-product-list`);
  if (!list)
    return;
  list.addEventListener("click", (event) => {
    const { target } = event;
    if (!(target instanceof HTMLElement))
      return;
    const parent = target.closest(`.boost-sd__filter-product-list`);
    if (!parent)
      return;
    const card = target.closest(`.Boost-Search-Card`);
    const inCard = !!card;
    if (inCard) {
      const variantId = card.dataset.productId;
      let state = history.state ?? {};
      state = {
        ...state,
        collection: {
          selected: variantId
        }
      };
      history.replaceState(state, "");
      if (variantId)
        window.ScrollBack = {
          variantId
        };
    }
    if (!isExcluded(target) && isIncluded(target))
      return;
    event.stopImmediatePropagation();
  }, { capture: true });
  function isExcluded(element) {
    const Exclude = [
      "Filter-Toggle"
    ];
    for (const name of Exclude) {
      if (element.classList.contains(name))
        return true;
      if (element.closest(`.${name}`))
        return true;
    }
    return false;
  }
  function isIncluded(element) {
    const Names = [
      "boost-sd__product-item-grid-view-layout-image",
      "boost-sd__product-title",
      "Product-Card-Details",
      "boost-sd-left",
      "boost-sd__pagination",
      "boost-sd__toolbar-container",
      "boost-sd__pagination-button",
      "Product-Card-Buy-More-Component",
      "Card-Product-Bulk",
      "Bonus-Label-Component",
      "Bonus-Popup-Dialog",
      "Card-Product-ATC"
    ];
    for (const name of Names) {
      if (element.classList.contains(name))
        return true;
      if (element.closest(`.${name}`))
        return true;
    }
    return false;
  }
  await pollFor({ selector: `.boost-sd__product-list` }).catch(() => {
    throw `Failed to find BoostAI's product list`;
  });
  list = document.querySelector(`.boost-sd__product-list`);
  if (list) {
    const element = list;
    if (!element.observer) {
      const observer = new MutationObserver((mutations) => {
        const additions = mutations.map((mutation) => mutation.addedNodes.length).reduce((a, b) => a + b, 0);
        console.debug("Changed", additions);
        if (additions)
          patchProducts();
      });
      observer.observe(list, {
        childList: true
      });
      element.observer = observer;
    }
    await patchProducts();
  }
}
async function patchProducts() {
  await pollFor({ selector: Pattern_Item }).catch(() => {
    throw `Failed to find BoostAI's product items`;
  });
  await collectItems();
}
async function collectItems() {
  const elements = document.querySelectorAll(Pattern_Item);
  const items = new Array;
  Array.from(elements).map((item, index) => ({ index, item, data: getProductData(item) })).filter(({ data }) => !!data).map(({ item, index, data }) => ({
    index,
    item,
    variant: data.variantId,
    handle: data.handle
  })).map((value) => {
    const html = Cache.get(value.variant);
    return { ...value, html };
  }).forEach(async (value) => {
    let { html, item } = value;
    if (!html) {
      items.push(value);
      return;
    }
    html = await html;
    if (html)
      furnish(item, html);
  });
  fetchItems(items);
}
function fetchItems(items) {
  const promises = new Array;
  while (items.length) {
    const batch = items.splice(0, 6);
    const finishers = new Array;
    const finish = (results) => finishers.forEach((finisher, index) => {
      const html = results[index];
      Cache.set(finisher.variant, html);
      furnish(finisher.item, html);
      finisher.handler(html);
    });
    let products = new Array;
    batch.forEach((value) => {
      const { variant, handle, index, item } = value;
      const promise = new Promise((resolve) => {
        finishers.push({
          variant,
          handle,
          item,
          handler: resolve
        });
      });
      Cache.set(variant, promise);
      const key = `${handle}*${variant}=${index}`;
      products.push(key);
    });
    const json = document.documentElement.dataset.context ?? "{}";
    const context = JSON.parse(json);
    const parameters = new Map;
    if (context.handle)
      parameters.set("Collection", context.handle);
    parameters.set("Products", products.join(","));
    const entries = Array.from(parameters.entries());
    const Batch_Divider = "###";
    const pairs = entries.map(([key, value]) => `${key}:${value}`).join(";");
    const payload = encodeURIComponent(pairs);
    const query = `${Endpoint_Product_Card}${payload}`;
    const url = new URL(query, location.href);
    const promise = fetch(url).then((response) => response.text()).then((text) => text.includes("❌") ? "" : text).then((html) => html.split(Batch_Divider)).then(finish);
    promises.push(promise);
  }
  Promise.allSettled(promises).then(() => scrollToSelected());
}
function getProductData(item) {
  const json = item.dataset.product;
  if (!json)
    return null;
  return JSON.parse(json);
}
